module.exports = __webpack_public_path__ + "img/img_14.4f5b2a83.webp";